import React from "react";
import NavBar from "../../NavBar"
import Footer from "../../Footer"
import datiBigiotteria from "../../../data/bigiotteriaProdotti.json";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { useEffect } from "react";
import ScrollabileRiga from "../ScrollabileRiga";
import Selezione from "../Selezione"

export default function Anelli(){

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    function tornaSopra(){
        document.body.scrollTop = 0; 
        document.documentElement.scrollTop = 0;
    }
    useEffect(() => {
            window.addEventListener("scroll",(e)=>{
            const bottone = document.getElementById("btnTop");
            if(window.scrollY===0){
                try {
                    bottone.classList.add("invisibile");
                } catch (error) {
                    return null;
                }
                
                
                setTimeout(() => {
                    try {
                        bottone.classList.add("invisibilePerDavvero")
                    } catch (error) {
                        return null;
                    }
                    
                }, "490");
                try {
                    bottone.classList.remove("visibile");
                } catch (error) {
                    return null;
                }
                
            }else{
                try {
                    bottone.classList.remove("invisibile");
                    bottone.classList.remove("invisibilePerDavvero");
                    bottone.classList.add("visibile");
                } catch (error) {
                    return null;
                }
                
            }
            
        });
        
    });
    
    const arrId = ["In Generale","Sezione四_中","Sezione C","Sezione Argento Uomo","Sezione Oro Uomo"]    
    return (
        <div className="bigiotteriaBody wuXieKeJi">
            <button id="btnTop" onClick={()=>tornaSopra()}><FontAwesomeIcon icon={faArrowUp} /></button>
            <NavBar uno ="Prodotti" due="Informazioni" tre="Contattaci" one="/prodotti" two="/informazioni" three="/contattaci"/>
            <h1 className="titoloProdotti">Anelli</h1>
            <Selezione arr={arrId}/>

            <div className="premessaProdotti">
                <p>A causa di un ecessivo numero di anelli, qui mostriamo in dettaglio solo alcuni modelli.</p>
            </div>
            
            <div className="colonna bigiotteria">

                <ScrollabileRiga idTitolo="InGenerale" titolo="In Generale Donna e Uomo" idScroll1="1" idScroll2="2" dati={datiBigiotteria} tipo="anelli" sottoTipo1="overView1" sottoTipo2="overView2" nomeDati="bigiotteriaProdotti"/>
                
                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="Sezione四_中" titolo="Sezione 四 e 中" idScroll1="3" idScroll2="4" dati={datiBigiotteria} tipo="anelli" sottoTipo1="si1" sottoTipo2="si2" nomeDati="bigiotteriaProdotti"/>

                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="SezioneC" titolo="Sezione C" idScroll1="5" idScroll2="6" dati={datiBigiotteria} tipo="anelli" sottoTipo1="c1" sottoTipo2="c2" nomeDati="bigiotteriaProdotti"/>

                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="SezioneArgentoUomo" titolo="Sezione Argento Uomo" idScroll1="7" idScroll2="8" dati={datiBigiotteria} tipo="anelli" sottoTipo1="ua1" sottoTipo2="ua2" nomeDati="bigiotteriaProdotti"/>
                
                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="SezioneOroUomo" titolo="Sezione Oro Uomo" idScroll1="9" idScroll2="10" dati={datiBigiotteria} tipo="anelli" sottoTipo1="uo1" sottoTipo2="uo2" nomeDati="bigiotteriaProdotti"/>

            </div>
            <Footer />
        </div>
    )
}